// Проекция прохождения для превью: всё, что нужно нарисовать интерактивный
// экран, посчитано ЗДЕСЬ. Превью не решает, что делает нижняя кнопка и когда
// она заперта, — иначе то же условие разъехалось бы по шести файлам.
import type { LessonCtaButtonState } from '@teach/ui'
import type { AnswerValue } from './answerState'
import type { LessonRun } from './useLessonRun'
import type { Verdict } from './verdict'
import { verdictGrade } from './verdictView'
import { pickMessages } from '@/i18n'
import type { ContentLang } from '@/features/editor/editorSlice'
import { messages } from './messages'

export interface PreviewRun {
  answer: AnswerValue
  setAnswer: (next: AnswerValue) => void
  /** `null` — ответ ещё не проверен. */
  verdict: Verdict | null
  ctaState: LessonCtaButtonState
  /**
   * Подпись нижней кнопки ПОСЛЕ проверки — «Далее», ровно как в плеере
   * (`BlockAnswerFooter` меняет отправку на `NextBlockButton`). До проверки
   * `null`: подпись знает сам блок, и у да/нет её нет вовсе.
   */
  ctaLabel: string | null
  ctaDisabled: boolean
  onCta: () => void
  /** Номер посещения экрана (`LessonRun.visitKey`) — по нему `renderBlockPreview`
   *  ставит `key`, и своё состояние превью не переезжает на следующий экран. */
  visitKey: number
  /** Прохождение прямо на холсте редактора: автор по-прежнему видит серые
   *  подсказки пустых полей (в предпросмотре урока — экран ученика — их нет). */
  onCanvas?: boolean
}

/** Оценки нет — цвет у кнопки нейтральный. Разбор общий (`verdictGrade`), а не
 *  сравнением строк: `LessonCtaButtonState` шире `Verdict`, и новый вариант
 *  вердикта прошёл бы здесь по типам молча. */
const ctaStateOf = (verdict: Verdict | null): LessonCtaButtonState => {
  const grade = verdictGrade(verdict)
  return grade === 'ungraded' ? 'idle' : grade
}

/** `lang` — язык курса: «Далее» на экране ученика подписан на нём, как в плеере. */
export const buildPreviewRun = (run: LessonRun, lang: ContentLang): PreviewRun => {
  const awaitingCheck = run.isGradable && run.verdict === null
  return {
    answer: run.answer,
    setAnswer: run.setAnswer,
    verdict: run.verdict,
    ctaState: ctaStateOf(run.verdict),
    // Проверять больше (или вовсе) нечего — кнопка честно ведёт дальше.
    ctaLabel: awaitingCheck ? null : pickMessages(messages, lang).next,
    ctaDisabled: awaitingCheck && !run.canCheck,
    onCta: awaitingCheck ? run.check : run.next,
    visitKey: run.visitKey,
  }
}
